/**
 * @file Lazily loads VueAxe to check for accessibility issues
 */
import environment from 'bits/environment'
import type { VueAxeOptions, VueAxePlugin } from 'vue-axe'

export async function getVueAxe(): Promise<VueAxePlugin | undefined> {
  return await new Promise((resolve) => {
    if (environment !== 'production') {
      import('vue-axe').then((vueAxe) => {
        resolve(vueAxe.default)
      })
    } else {
      resolve(undefined)
    }
  })
}

export function getVueAxeOptions(): VueAxeOptions {
  return {
    allowConsoleClears: false,
    clearConsoleOnUpdate: false,
  }
}
